<template>
    <div>
        <!-- <div class="screen clearfix">
            <div class="fl">
                <h2 class="ovhidden">{{eventName}}</h2>
                <p class="mt10">{{startDate}} ~ {{endDate}}</p>
            </div>
            <div class="event-detail-operation fr">
                <i class="event-detail-icon icons word-icon cp" @click="lookEvent('word',eventId);" title="下载Word"></i>
                <i class="event-detail-icon icons pdf-icon cp" @click="lookEvent('pdf',eventId);" title="下载PDF"></i>
                <div class="event-detail-icon">
                    <i class="iconfont icon-EWM cp fs22 db"></i>
                    <div class="url-fu" ref="qrCodeUrl"></div>
                </div>
            </div>
        </div> -->
        <!-- <div class="warp mt20">
            
        </div> -->
        <div class="iframe-warp">
            <div class="event-detail-operation fr">
                <div class="event-detail-icon">
                    <i class="iconfont icon-EWM cp fs22 db"></i>
                    <div class="url-fu" ref="qrCodeUrl"></div>
                </div>
                <i class="event-detail-icon icons word-icon cp" @click="lookEvent('word',eventId);" title="下载Word"></i>
                <i class="event-detail-icon icons pdf-icon cp" @click="lookEvent('pdf',eventId);" title="下载PDF"></i>
            </div>
            <iframe class="warp-body iframe mt20" :height="high" :src="iframUrl" id="frameObj" style="background:#fff;"></iframe>
        </div>
	</div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
    data() {
        return {
            eventId:'',
            eventName:'',
            startDate:'',
            endDate:'',
            url:'',
            iframUrl:'',
            high:''//iforme高度
        }
    },
    mounted() {
        this.eventId = this.$route.query.id;
        this.eventName = this.$route.query.name;
        this.startDate = this.$route.query.startDate;
        this.endDate = this.$route.query.endDate;
        this.url = this.$route.query.url;
        this.iframUrl = this.$route.query.iframUrl;
        this.high = window.innerHeight - 94;
        window.onresize = function (){
           this.high = window.innerHeight - 94;
        }
        this.creatQrCode();
    },
    created() {
        
    },
    methods: {
        // 预览事件
        lookEvent (type,id){
            let that = this;
            that.$api.get('event/event/report',{type:type,eventId:id},r =>{
                that.$utils.returnCode(r,function(){
                    window.open(r.data.url);
                })
            })
        },
        // 生成二维码
        creatQrCode() {
            let that = this;
            let qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: that.url, // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/productCenter/eventsHtml.vue